import { FormLabel, Grid } from "@mui/material";
import GameCategoryItem from "./game-category-item";
import { useSelector } from 'react-redux';
import type { RootState } from '../../types/store';

type GameCategoryListDisplayProps = {
  gameMode: number;
  onChange: Function;
  selectedCategories: number[];
}

export default function GameCategoryListDisplay({gameMode, onChange, selectedCategories}: GameCategoryListDisplayProps) {
    const translate = useSelector((state:RootState) => state.ui.language);
    const settings = useSelector((state:RootState) => state.settings);

    function onToggleSelectCategory(id: number) {
        onChange(id);
    }

    const filteredCategories = settings.categories.flatMap((category) => {
        if(category.availableModes.includes(gameMode)) {
            const match = translate.categories.find(c => c.id === category.id);
            if (match) {
                return [{ id: category.id, icon: category.icon, color: category.color, name: match.name, description: match.description }];
            }
        }
        return [];
    });
    
    return (
        <>
            <FormLabel>{translate.create.categories}</FormLabel>
            <Grid container gap={1}>
                {filteredCategories.map((item, i) => (
                    <Grid key={item.id} size={{xs: 12, md: translate.categories.length % 2 != 0 && i == translate.categories.length - 1 ? 12 : 5.9 }}>
                        <GameCategoryItem icon={item.icon} color={item.color} category={item} selected={selectedCategories.includes(item.id)} onToggle={() => { onToggleSelectCategory(item.id) }} />
                    </Grid>
                ))}
            </Grid>
        </>
    );
}
